'use client';

import Script from 'next/script';

type OptimezelyProps = {
	disabled: boolean;
};

export function Optimizely({ disabled }: OptimezelyProps) {
	return disabled ? null : <Script src="https://cdn.optimizely.com/js/183805907.js" />;
}
